module.exports = __webpack_public_path__ + "img/bell_1.6fd92631.jpg";